
































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import Badges from './Badges.vue';
import Params from './Params.vue';
import ApiRequestReturnParams from './ApiRequestReturnParams.vue';
import Returns from './Returns.vue';
import StatusBadge from '@/components/ui/StatusBadge.vue';
import PlatformSpecification from './PlatformSpecification.vue';
import Signature from './signature/Signature';
import CopyUrlButton from '@/components/ui/buttons/CopyUrlButton.vue';
import CodeExample from '@/components/docs-main/code-rails-view/CodeExampleBody.vue';
import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames } from '@/templates/DataNames';
import { BadgesType, referencesMethod } from '@/templates/References';
import { convertToHtmlHelper, getSelectedLangName } from '@/heplers';
import { LanguagesPack, SelectedLanguagesPack } from '@/store/types';
import { convertToAnchorIdHelper, getLastNameHelper } from '@/heplers/stringHelpers';
import { CodeExampleObservers } from '@/heplers/codeExampleObservers';

interface grpcObject {
  [grpc: string]: string;
}

@Component({
  components: {
    DocIcon,
    Badges,
    Params,
    Returns,
    ApiRequestReturnParams,
    StatusBadge,
    PlatformSpecification,
    Signature,
    CopyUrlButton,
    CodeExample,
  },
  filters: {
    getLastName: getLastNameHelper,
    convertToAnchorId: convertToAnchorIdHelper,
    toLowerCase: (string: string) => {
      if (!string) return;
      return string.toLowerCase();
    },
  },
})
export default class Method extends Vue {
  @Prop(Object) method: referencesMethod;
  @Getter('getSelectedLanguagesPack') languagesPack: SelectedLanguagesPack;
  @Getter('getContent') content: any;

  roles = [
    'Owner',
    'Accountant',
    'Developer',
    'Phone number manager',
    'Support',
    'SMS Manager',
    'Admin',
    'Supervisor',
    'Payer (disabled list of verifications)',
    'Payer',
    'User manager',
    'Call list manager',
    'User list write',
    'User list view',
    'ACD management',
    'Call history view',
    'Verification access',
    'Scenarios access',
  ];
  /**
   * Собираем объект для alert блоков
   */
  get statusBadges() {
    if (!this.method.attributes) return {};

    const allowedBadgeNames: BadgesType[] = Object.values(BadgesType);

    const filter = (attributes: any, allowedBadgeNames: any) =>
      allowedBadgeNames.reduce((acc: any, name: any) => {
        if (attributes[name] && typeof attributes[name] === 'string') {
          acc[name] = attributes[name];
        }
        return acc;
      }, {});

    return filter(this.method.attributes, allowedBadgeNames);
  }

  get isUnitySdkEvents() {
    return this.method?.fqdn?.split('.')[1] === 'unitysdk' && this.method?.kind === 'events';
  }

  get currentLanguage() {
    //@ts-expect-error: his comparison appears to be unintentional
    return this.languagesPack[<keyof LanguagesPack>getSelectedLangName(this.$route.meta.fqdn)] ===
      'c#'
      ? 'csharp'
      : this.languagesPack[<keyof LanguagesPack>getSelectedLangName(this.$route.meta.fqdn)];
  }

  get isManagementApi() {
    return (
      this.content.root_fqdn === 'references.httpapi' &&
      this.content.root_fqdn !== 'references.httpapi.errors'
    );
  }

  /**
   * Фильтр, для методов не доступных в рамках текущего языка
   */
  get checkAllowedForCurrentLanguage() {
    if (this.method?.attributes?.[this.currentLanguage] === false) {
      return false;
    }

    return true;
  }

  mounted() {
    // @ts-expect-error: refers to a UMD global, but the current file is a module.
    // eslint-disable-next-line no-undef
    if (this.$refs.content) Prism.highlightAllUnder(this.$refs.content);
  }

  convertToHtml(mdString: string) {
    if (!mdString) return;

    return convertToHtmlHelper(mdString);
  }

  getTitle(title: string | grpcObject) {
    if (typeof title == 'object' && title.grpc) {
      return title.grpc;
    } else return title;
  }

  goToCodeExamples(_examples: any): void {
    let anchorId = this.method.uniqId;
    CodeExampleObservers.setCurrentCodeButton(anchorId);

    GlobalBus.emit(GlobalBusNames.CHANGEEXAMPLE, anchorId);
  }
}
